module.exports = __webpack_public_path__ + "static/media/icon-emoji-sad.9f24a949.svg";